module.exports = __webpack_public_path__ + "static/img/no_pic.98fc6a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no_pic.png
// module id = XXph
// module chunks = 1